<template>
    <CarConfirmAction :car="car">
        Вы действительно хотите согласовать этот автомобиль?
    </CarConfirmAction>

    <div v-if="errorMessages.length > 0" class="form__content">
        <span v-for="errorMessage in errorMessages" class="form-field__error">
            {{ errorMessage }}
        </span>
    </div>
</template>

<script lang="ts" setup>
    import { computed, Ref } from 'vue';
    import { inject } from '@vue/runtime-core';

    import { Car, CarApproveFormErrors } from '@/types/car.type.ts';

    import CarConfirmAction from '@/components/cars/CarConfirmAction/CarConfirmAction.vue';

    const { car } = defineProps<{
        car: Car,
    }>();

    const errors = inject('errors', {}) as Ref<CarApproveFormErrors, CarApproveFormErrors>;

    const errorMessages = computed<string[]>(() => {
        return (errors.value.photos ?? [])
            .concat(errors.value.videos ?? [])
            .concat(errors.value.documents ?? []);
    });
</script>
